import { render, staticRenderFns } from "./StoryblokResolver.vue?vue&type=template&id=7df0473f&"
import script from "./StoryblokResolver.vue?vue&type=script&lang=js&"
export * from "./StoryblokResolver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports